import { MastraClient } from '@mastra/client-js';
import { useMemo } from 'react';

import { fetchWithCurrentSessionJwt } from '../../auth/fetchWithCurrentSessionJwt';
import { LLM_SERVICE_BASE_URL } from '../../config/config';

const createMastraClient = () => {
    return new MastraClient({
        baseUrl: LLM_SERVICE_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
        },
        fetch: fetchWithCurrentSessionJwt,
    });
};

export const useMastraClient = () => {
    return useMemo(() => createMastraClient(), []);
};
